import { TOptions } from 'i18next';
import { $Dictionary } from 'i18next/typescript/helpers';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

type options = TOptions<$Dictionary>;

type TranslatorProps = {
  path: string | string[];
  suffix?: string;
  options?: options;
};

const Translator = ({ path, options, suffix }: TranslatorProps) => {
  const { t, i18n } = usei18nextTranslation();

  // Just return the translation directly - let react-i18next handle missing keys
  return (
    <span>
      {t(path, options)}
      {suffix}
    </span>
  );
};

export const useTranslation = () => {
  const { t, ready, i18n } = usei18nextTranslation();

  return {
    t: (path: string | string[], options?: options) => {
      return t(path, options);
    },
    ready,
    i18n
  };
};

export default Translator;
